import { Select } from './Select';

export const tipoMargens: Select[] = [
  {
    value: 0,
    label: 'Mark-Up',
  },
  {
    value: 2,
    label: 'Mark-Down',
  },
];
